import React from 'react';
import {
  User, Phone, MessageCircle,
  // Calendar
} from 'lucide-react';
import { LeadsStats } from '../hooks/useLeadsData';

interface StatsCardsProps {
  stats: LeadsStats;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <div className="bg-white rounded-xl shadow-sm border border-tinta/10 p-5 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-3">
          <div className="h-10 w-10 rounded-lg bg-bordo/10 border border-bordo/20 flex items-center justify-center">
            <User className="h-5 w-5 text-bordo" />
          </div>
        </div>
        <p className="font-display text-3xl font-black text-tinta">
          {stats.total_leads.toLocaleString()}
        </p>
        <p className="text-sm text-tinta-soft mt-1">Total de Clientes</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-tinta/10 p-5 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-3">
          <div className="h-10 w-10 rounded-lg bg-musgo/10 border border-musgo/20 flex items-center justify-center">
            <Phone className="h-5 w-5 text-musgo" />
          </div>
        </div>
        <p className="font-display text-3xl font-black text-tinta">
          {stats.unique_leads.toLocaleString()}
        </p>
        <p className="text-sm text-tinta-soft mt-1">Clientes Únicos</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-tinta/10 p-5 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-3">
          <div className="h-10 w-10 rounded-lg bg-mostarda/20 border border-mostarda/40 flex items-center justify-center">
            <MessageCircle className="h-5 w-5 text-mostarda-dark" />
          </div>
        </div>
        <p className="font-display text-3xl font-black text-tinta">
          {stats.leads_with_prizes.toLocaleString()}
        </p>
        <p className="text-sm text-tinta-soft mt-1">Ganharam Prêmios</p>
      </div>

      {/* <div className="bg-white rounded-xl shadow-sm border border-tinta/10 p-5 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-3">
          <div className="h-10 w-10 rounded-lg bg-bordo/10 border border-bordo/20 flex items-center justify-center">
            <Calendar className="h-5 w-5 text-bordo" />
          </div>
        </div>
        <p className="font-display text-3xl font-black text-tinta">{stats.conversion_rate}%</p>
        <p className="text-sm text-tinta-soft mt-1">Taxa de Conversão</p>
      </div> */}
    </div>
  );
};

export default StatsCards;
